import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=c955d5bc&scoped=true"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"
import style0 from "./Address.vue?vue&type=style&index=0&id=c955d5bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c955d5bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c955d5bc')) {
      api.createRecord('c955d5bc', component.options)
    } else {
      api.reload('c955d5bc', component.options)
    }
    module.hot.accept("./Address.vue?vue&type=template&id=c955d5bc&scoped=true", function () {
      api.rerender('c955d5bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/user/components/Address.vue"
export default component.exports